module.exports = __webpack_public_path__ + "banner.gif?d8facfacf39965c2b2b18f121bbb547d";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner.gif
// module id = 14
// module chunks = 0 1